import { useMediaQuery } from '@/legacy-src/hooks/useMediaQuery'
import { tailwindConfig } from '@/legacy-src/utilities/tailwind'

export const useIsTablet = () => useMediaQuery(`(max-width: ${tailwindConfig.theme.screens['laptop']})`)
